import { OrderRecipientAction } from '../../enums/order/order-recipient-action.enum';

export const RecipientActionTranslationMapper = new Map([
  [OrderRecipientAction.ReviewDocuments, 'CONTRACT_ORDER.REVIEW_DOCUMENT'],
  [OrderRecipientAction.SignDocuments, 'CONTRACT_ORDER.SIGN_DOCUMENT'],
  [OrderRecipientAction.ReceiveACopy, 'CONTRACT_ORDER.RECEIVE_COPY'],
]);
